import CommentIcon from '@mui/icons-material/Comment';
import CommentsDisabledIcon from '@mui/icons-material/CommentsDisabled';
import { Badge, IconButton } from '@mui/material';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { useGlobalStore } from '@/store';

export const ChatNavButton = () => {
    const chatAssistantEnabled = useFeatureFlag('chatAssistantEnabled');
    const isChatOpen = useGlobalStore((state) => state.isChatOpen);
    const setIsChatOpen = useGlobalStore((state) => state.setIsChatOpen);
    const hasUnreadChatMessage = useGlobalStore((state) => state.hasUnreadChatMessage);
    const setHasUnreadChatMessage = useGlobalStore((state) => state.setHasUnreadChatMessage);

    if (!chatAssistantEnabled) {
        return false;
    }

    const handleClick = () => {
        if (!isChatOpen) {
            setHasUnreadChatMessage(false);
        }
        setIsChatOpen(!isChatOpen);
    };

    return (
        <IconButton
            size="large"
            aria-label={isChatOpen ? 'Close chat' : 'Open chat assistant'}
            onClick={handleClick}
            color="inherit"
        >
            <Badge variant="dot" color="error" invisible={!hasUnreadChatMessage} data-testid="chat-unread-badge">
                {isChatOpen ? <CommentsDisabledIcon /> : <CommentIcon />}
            </Badge>
        </IconButton>
    );
};
